module.exports = __webpack_public_path__ + "static/media/image5.b92cff70.png";